import { Link, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { useCurrentUser } from "@/hooks/useCurrentUser";

// Routes where the banner would be noise (you're already acting on it).
const HIDE_ON = ["/subscribe", "/onboarding"];

/**
 * Persistent "you're on the demo" strip shown to signed-in users who have
 * onboarded (have a class) but don't yet hold an active subscription. Demo
 * users can browse free sample chapters; premium content shows the existing
 * PaywallCard. SUPER_ADMIN bypasses content gating, so they never see this.
 */
export function DemoBanner() {
  const { status } = useAuth();
  const me = useCurrentUser();
  const location = useLocation();

  const user = me.data;
  const show =
    status === "authenticated" &&
    !!user &&
    user.role_id !== "SUPER_ADMIN" &&
    !!user.class_id &&
    !user.active_subscription_id &&
    !HIDE_ON.some((p) => location.pathname.startsWith(p));

  if (!show) return null;

  return (
    <div className="border-b border-brand-soft-strong/40 bg-brand-soft">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2.5 sm:px-6">
        <Sparkles className="h-4 w-4 shrink-0 text-brand" />
        <p className="flex-1 text-sm text-text">
          <span className="font-medium">You're on the demo version.</span>{" "}
          <span className="text-text-muted">Subscribe to unlock every chapter for your class.</span>
        </p>
        <Button size="sm" asChild className="shrink-0">
          <Link to="/subscribe">Subscribe</Link>
        </Button>
      </div>
    </div>
  );
}
